import { Button } from 'antd';
import { stopGuide } from 'containers/Guide/store/guide/actions';
import { t } from 'helpers/i18n';
import {
  getCurrentSubStep,
  GuideSubStep,
  isLastStep,
} from 'data/ui/guide/Guide';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Tour from 'reactour';
import { RootState } from 'store/reducer';
import { localizationHelpers } from 'helpers';

const { getCurrentLanguage } = localizationHelpers;

const AppTour: React.FC = () => {
  const dispatch = useDispatch();
  const onGoingGuide = useSelector(
    (state: RootState) => state.guide.onGoingGuide
  );
  const steps = (onGoingGuide ? [getCurrentSubStep(onGoingGuide)] : []).map(
    (e: GuideSubStep) => ({
      selector: e.selector,
      content: e.content[getCurrentLanguage()],
    })
  );
  const isLastGuideStep = isLastStep(onGoingGuide);

  return (
    <Tour
      showButtons={isLastGuideStep}
      showNavigation={false}
      showNumber={false}
      showCloseButton={false}
      scrollDuration={1000}
      prevButton={<></>}
      lastStepNextButton={<Button type="primary">{t('Finish Guide')}</Button>}
      rounded={5}
      steps={steps}
      isOpen={!!onGoingGuide && onGoingGuide.isGUIReady}
      onRequestClose={() => {
        dispatch(stopGuide());
      }}
    />
  );
};

export default AppTour;
